import React, { useCallback } from "react";
import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TransactionFilters from "./TransactionFilters";
import WithdrawalFilters from "./WithdrawalFilters";
import DataTable from "examples/Tables/DataTable";
import ConfirmModal from "../../../components/ConfirmModal/ConfirmModal";

import useTransactionsHook from "../../../hooks/useTransactionsHook";

const Transactions = ({ transactionType }) => {
  const {
    isLoading,
    columns,
    rows,
    currentPage,
    perPage,
    setCurrentPage,
    setPerPage,
    sortBy,
    setSortBy,
    totalCount,
    totalPage,
    setUserId,
    setPropertyId,
    setFilterObj,
    onDownloadCSV,
    onDownloadXLSX,
    isApproveModal,
    onCloseModal,
    onApproveClick,
    searchTerm,
    setSearchTerm,
    handleApproveStatus,
    isApprovedFilterValue,
    setIsApproveFilterValue,
    isApproveLoading,
  } = useTransactionsHook({
    transactionType,
  });

  const getTitleBackground = useCallback(() => {
    switch (transactionType) {
      case "primary":
      case "secondary":
      case "withdrawal":
        return "info";

      case "open":
        return "dark";

      case "cancelled":
        return "error";

      default:
        return "info";
    }
  }, [transactionType]);

  const getTabTitle = useCallback(() => {
    switch (transactionType) {
      case "primary":
        return "Primary Market Transactions";

      case "secondary":
        return "Secondary Market Transactions";

      case "open":
        return "Open Orders";

      case "cancelled":
        return "Cancelled Orders";

      case "withdrawal":
        return "Bank Withdrawal Transactions";

      default:
        return "Primary Market Transactions";
    }
  }, [transactionType]);

  return (
    <>
      <MDBox
        mx={2}
        mt={3}
        py={3}
        px={2}
        variant="gradient"
        bgColor={getTitleBackground()}
        borderRadius="lg"
        coloredShadow={getTitleBackground()}>
        <MDTypography variant="h6" color="white">
          {getTabTitle()}
        </MDTypography>
      </MDBox>
      {transactionType !== "withdrawal" && (
        <TransactionFilters
          setUserId={setUserId}
          setPropertyId={setPropertyId}
          setFilterObj={setFilterObj}
          onDownloadCSV={onDownloadCSV}
          onDownloadXLSX={onDownloadXLSX}
        />
      )}

      {transactionType === "withdrawal" && (
        <WithdrawalFilters
          handleApproveStatus={handleApproveStatus}
          isApprovedFilterValue={isApprovedFilterValue}
          setIsApproveFilterValue={setIsApproveFilterValue}
        />
      )}

      <MDBox
        pt={3}
        sx={{
          position: "relative",
          paddingTop: "85px",
          paddingBottom: {
            xs: "150px",
            sm: "95px",
          },
        }}>
        <DataTable
          table={{ columns, rows }}
          isSorted={true}
          entriesPerPage={{ defaultValue: perPage }}
          showTotalEntries
          canSearch
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          perPage={perPage}
          setPerPage={setPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPage={totalPage}
          totalRecords={totalCount}
          // hiddenColumns={['id']}
          queryPageSortBy={[sortBy]}
          setSortBy={setSortBy}
          isLoading={isLoading}
          onRowClick={(userId) => {
            transactionType === "withdrawal" &&
              window.open(`/users/${userId}`, "_self");
          }}
          isRowClickable={transactionType === "withdrawal"}
        />
      </MDBox>
      {isApproveModal && (
        <ConfirmModal
          open={isApproveModal}
          onOkayClick={onApproveClick}
          onCloseModal={onCloseModal}
          modalText={`Are you sure you want to Approve this transaction?`}
          okayText={`Yes Sure`}
          cancelText="No, cancel"
          success
          isLoading={isApproveLoading}
        />
      )}
    </>
  );
};

Transactions.propTypes = {
  transactionType: PropTypes.oneOf([
    "primary",
    "secondary",
    "open",
    "cancelled",
  ]),
};

Transactions.defaultProps = {
  transactionType: "primary",
};

export default Transactions;
